exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Imports
var urlEscape = require("../../../../../../node_modules/css-loader/dist/runtime/url-escape.js");
var ___CSS_LOADER_URL___0___ = urlEscape(require("@tencent/docs-design-resources/icon/desktop/svg/toolbar_close_red_24.svg"));

// Module
exports.push([module.id, ".style-toolbar-exit-master-edit-1SouS{background-image:url(" + ___CSS_LOADER_URL___0___ + ")}", ""]);

// Exports
exports.locals = {
	"toolbar-exit-master-edit": "style-toolbar-exit-master-edit-1SouS"
};